import { render, staticRenderFns } from "./ExpedicaoSequenciaForm.vue?vue&type=template&id=24971799"
import script from "./ExpedicaoSequenciaForm.vue?vue&type=script&lang=js"
export * from "./ExpedicaoSequenciaForm.vue?vue&type=script&lang=js"
import style0 from "./ExpedicaoSequenciaForm.vue?vue&type=style&index=0&id=24971799&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports